/**
 * The paths this bundle serves.
 *
 * Plain data, deliberately free of React and of component imports: this module
 * is imported by vite.config.js as well as by main.jsx, and pulling the page
 * tree into the Vite config would mean bundling JSX just to read four strings.
 *
 * Three places used to carry their own copy of this list and drift apart:
 *   - main.jsx, which picks the component for the current URL;
 *   - vite.config.js, whose dev middleware rewrites these paths to index.html
 *     (macOS has a case-insensitive filesystem, so Vite resolving `/support`
 *     against resolve.extensions finds Support.jsx and answers with the
 *     transformed module instead of the page);
 *   - server/static.js in production, which serves index.html for anything
 *     that is not a real file and therefore needs no list at all.
 *
 * Adding a page is one entry here plus its component in main.jsx, and main.jsx
 * throws at boot if the two ever disagree.
 */
export const ROUTE_PATHS = ['/', '/privacy-policy', '/docs', '/support'];

/**
 * Paths that used to be routes and now redirect, permanently. `/user-guide` was
 * the guide's address until it became `/docs`, and it is in the sitemap, in the
 * PDFs handed to admins and in whatever emails already went out — dropping it
 * would 404 every one of those. Honoured by the dev server (vite.config.js),
 * the production server (server/static.js) and, as a last resort for a cached
 * index.html, the client itself (main.jsx).
 */
export const LEGACY_PATHS = { '/user-guide': '/docs' };

/**
 * `/support/` and `/support` are the same page. Production redirects the
 * trailing slash away in server/static.js; this keeps dev and the client-side
 * lookup agreeing with it.
 */
export function normalizePath(pathname) {
  const path = (pathname || '').split('?')[0].replace(/\/+$/, '');
  return path || '/';
}
